module.exports = __webpack_public_path__ + "static/img/shop-img.3615f12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion/shop-img.png
// module id = sBFj
// module chunks = 2